// Constants for entitlements management
export const AVAILABLE_FEATURES = [
  {
    id: 'feature-upload',
    name: 'Upload',
    description: 'File upload functionality',
  },
  {
    id: 'feature-download',
    name: 'Download',
    description: 'File download functionality',
  },
  {
    id: 'feature-storage',
    name: 'Storage',
    description: 'Data storage capacity',
  },
  {
    id: 'feature-api-calls',
    name: 'API Calls',
    description: 'API request limits',
  },
  {
    id: 'feature-bandwidth',
    name: 'Bandwidth',
    description: 'Network bandwidth usage',
  },
]

export const USAGE_RESET_OPTIONS = [
  { value: 'never', label: 'Never' },
  { value: 'hourly', label: 'Every Hour' },
  { value: 'daily', label: 'Every Day' },
  { value: 'weekly', label: 'Every Week' },
  { value: 'monthly', label: 'Every Month' },
  { value: 'yearly', label: 'Every Year' },
]
